// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-input {
  border-bottom: 1px solid;
}

ion-item {
  font-size: 0.9rem;
  --min-height: 28px;
}

.editField > ion-item {
  --min-height: 28px;
}

.fielditem {
  --background: transparent;
  background: transparent;
}

.modelRowContainer > div:nth-of-type(odd) {
  background: #f2f2f2;
}

.modelRowContainer > div:nth-of-type(even) {
  background: #ffffff;
}

.whiteBg {
  background: #ffffff;
}

ion-item {
  padding: 0px;
}

.listTable td {
  border: 0px solid #ddd;
  line-height: 1.4rem;
}

.listTable td {
  border-bottom: 1px solid #ddd;
}

th {
  white-space: nowrap;
  padding: 5px;
}

.showScrollX {
  width: 100%;
  overflow-x: scroll;
  overscroll-behavior: contain;
}

.showScrollY {
  height: 700px;
  overflow-y: scroll;
  overscroll-behavior: contain;
}

.regTd > div:nth-of-type(odd) {
  background: #f2f2f2;
}

.regTd > div:nth-of-type(even) {
  background: #ffffff;
}

.regTd > ion-item {
  background: transparent;
}

.regTd > ion-item .item-inner {
  overflow: hidden;
  background: transparent;
}

.inTableImage {
  max-width: 30px;
  max-height: 30px;
}

.inTableImage ion-img,
.inTableImage img {
  max-width: 60px;
  max-height: 60px;
}

.datarow:hover {
  border: 1px solid black;
}

.myrow {
  display: flex;
}

.displayNameField {
  box-shadow: rgb(45, 45, 45) 0px 0px 1px;
}

.td1 {
  display: flex;
  flex-basis: 20px;
}

.td2 {
  display: flex;
  flex-basis: 20px;
}

.td12 .checkMarkInTd {
  display: none;
}

.td12:hover .checkMarkInTd {
  display: block;
}

.tdCheckBox {
  max-height: 60px;
}

.thDisplayName {
  flex-basis: 110px;
}

.td12 {
  position: relative;
  z-index: 22;
  align-content: flex-start;
  display: flex;
  flex-basis: 100px;
  background-color: #e1e1e1;
  width: 100px;
  max-width: 100px;
}

.td15 {
  z-index: 999999;
  flex-basis: 225px;
  max-width: 225px;
}

.noScroll {
  animation: fadeInFromNone 0.5s ease-out;
}

@keyframes fadeInFromNone {
  0% {
    display: none;
    opacity: 0;
  }
  1% {
    display: block;
    opacity: 0;
  }
  100% {
    display: block;
    opacity: 1;
  }
}
.onScroll {
  opacity: 0;
}

.tDtransition {
  transition: flex-basis 0.3s;
  transform: translateX(-3000);
  animation: translateXAnimation 2s none;
}

@keyframes translateXAnimation {
  0% {
    transform: translateX(0);
  }
}
.tDwidtherOnHover {
  transition: flex-basis 0.3s;
}

.tDwidtherOnHover:hover span {
  width: 35px;
  padding-left: 10px;
}

.tDwidtherOnHover:hover {
  flex-basis: 65px;
  cursor: pointer;
}

.tDwidtherOnHover1:hover {
  flex-basis: 90px;
  cursor: pointer;
}

.nottDwidtherChecked {
  flex-basis: 20px;
}

.tDwidtherChecked {
  flex-basis: 45px;
  cursor: pointer;
}

.tDwidtherChecked1 {
  flex-basis: 90px;
  cursor: pointer;
}

.disabledDiv {
  background-color: #d3e2ff;
}

.onFieldMouseOver {
  background-color: #fac75a;
}

.thButtonCOl {
  display: flex;
  flex-basis: 140px;
}

.th3 {
  display: flex;
  flex-basis: 300px;
  background: white;
  position: relative;
  z-index: 213332;
}

.td3 {
  display: flex;
  flex-basis: 300px;
  color: white;
  position: relative;
  z-index: 22;
  padding: 0px 3px;
}

.borderit {
  border-right: 1px solid #c7c7c7;
}

.mainBackcolor {
  background-color: var(--ion-color-secondary);
}

.mainBackcolor1 {
  background-color: var(--ion-color-warning);
}

.tdId {
  display: flex;
  flex-basis: 100px;
}

.fullFlex {
  flex-basis: 100%;
}

.Flex80 {
  flex-basis: 80%;
}

.sidecard {
  max-height: 661px;
  overflow-x: scroll;
}

.showOnHover {
  cursor: pointer;
}

.showOnHover:hover {
  border: 1px dashed;
  background-color: #efefef;
}

.showOnHoverDark:hover {
  background-color: #bebebe;
}

.showOnHover .showOnHoverSon {
  visibility: hidden;
}

.showOnHover .showOnHoverSonTop {
  top: -20px;
  position: relative;
  z-index: 111;
}

.showOnHover:hover .showOnHoverSon {
  visibility: visible;
}

.displayOnHover2 .displayOnHoverSon2 {
  display: none;
}

.displayOnHover2:hover .displayOnHoverSon2 {
  display: initial;
}

.tdFullOnHover:hover {
  min-width: -moz-fit-content;
  min-width: fit-content;
  flex-basis: auto !important;
}

.transitionFromHidden {
  width: 0;
}

.transitionFromHiddenOpen {
  transition: width 0.5s ease-in-out;
  width: auto;
}

.checkButton ion-button {
  height: 80px;
}

.checkButton ion-icon {
  font-size: 1.5rem;
}

.boxCheck ion-icon {
  visibility: hidden;
}

.boxCheck {
  width: 30px;
}

.boxCheck:hover {
  width: 70px;
  transition: width 0.3s;
}

.boxCheck:hover ion-icon {
  visibility: visible;
}

.middleBoxSmaller {
  width: 50px;
  transition: width 0.3s;
}

.field {
  white-space: break-spaces;
  overflow-x: hidden;
  overflow-y: hidden;
  max-height: 60px;
}

.listTableContainerSide {
  width: 100%;
  max-height: 700px;
  overflow-y: scroll;
}

.addNew {
  max-width: 700px;
  border-color: #a3a3a3;
  border: 1px dashed;
}

.boxView {
  max-width: 100%;
  float: left;
  padding: 8px;
  min-width: 300px;
}

.modelRow {
  -webkit-transition-webkit-transition: opacity 0.5s ease-in-out;
  transition: opacity 1s ease-in-out;
  opacity: 1;
}

.opacityTransition {
  -webkit-transition-webkit-transition: opacity 0.5s ease-in-out;
  transition: opacity 3s ease-in-out;
  opacity: 1;
}

.modelRemoved {
  opacity: 0;
}

.onRefresh {
  opacity: 0;
}

.sticktTableHeader {
  position: fixed;
  z-index: 19911;
  margin-bottom: 8px;
  top: 60px;
}

.relationOpenMain {
  flex-basis: 80%;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/view-table/view-table.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;AACF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,uBAAA;AAFF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,YAAA;AA1BF;;AA8BA;EACE,sBAAA;EAEA,mBAAA;AA5BF;;AA+BA;EACE,6BAAA;AA5BF;;AA+BA;EACE,mBAAA;EACA,YAAA;AA5BF;;AA+BA;EACE,WAAA;EACA,kBAAA;EACA,4BAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,kBAAA;EACA,4BAAA;AA5BF;;AAyCA;EACE,mBAAA;AAtCF;;AAyCA;EACE,mBAAA;AAtCF;;AA0CA;EACE,uBAAA;AAvCF;;AA2CA;EACE,gBAAA;EAEA,uBAAA;AAzCF;;AA4CA;EACE,eAAA;EACA,gBAAA;AAzCF;;AA8CA;;EAEE,eAAA;EACA,gBAAA;AA3CF;;AAsDA;EAEE,uBAAA;AApDF;;AAuDA;EACE,aAAA;AApDF;;AAgEA;EACE,uCAAA;AA7DF;;AAqEA;EACE,aAAA;EACA,gBAAA;AAlEF;;AAqEA;EACE,aAAA;EACA,gBAAA;AAlEF;;AAqEA;EACE,aAAA;AAlEF;;AAqEA;EACE,cAAA;AAlEF;;AAqEA;EACE,gBAAA;AAlEF;;AAqEA;EACE,iBAAA;AAlEF;;AAqEA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EAEA,yBAAA;EAEA,YAAA;EACA,gBAAA;AApEF;;AAuEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AApEF;;AA2EA;EAIE,uCAAA;AAxEF;;AA2EA;EACE;IACE,aAAA;IACA,UAAA;EAxEF;EA2EA;IACE,cAAA;IACA,UAAA;EAzEF;EA4EA;IACE,cAAA;IACA,UAAA;EA1EF;AACF;AA6EA;EACE,UAAA;AA3EF;;AA8EA;EACE,2BAAA;EACA,4BAAA;EACA,sCAAA;AA3EF;;AA8EA;EACE;IACE,wBAAA;EA3EF;AACF;AA8EA;EACE,2BAAA;AA5EF;;AA+EA;EACE,WAAA;EACA,kBAAA;AA5EF;;AA+EA;EACE,gBAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,gBAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,gBAAA;AA5EF;;AA+EA;EACE,gBAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,gBAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,yBAAA;AA5EF;;AA+EA;EACE,yBAAA;AA5EF;;AA+EA;EACE,aAAA;EACA,iBAAA;AA5EF;;AA+EA;EACE,aAAA;EAEA,iBAAA;EAIA,iBAAA;EACA,kBAAA;EACA,eAAA;AAhFF;;AAoFA;EACE,aAAA;EACA,iBAAA;EAEA,YAAA;EAIA,kBAAA;EACA,WAAA;EACA,gBAAA;AArFF;;AAyFA;EACE,+BAAA;AAtFF;;AAyFA;EACE,4CAAA;AAtFF;;AAyFA;EACE,0CAAA;AAtFF;;AAyFA;EACE,aAAA;EACA,iBAAA;AAtFF;;AAyFA;EACE,gBAAA;AAtFF;;AAyFA;EACE,eAAA;AAtFF;;AA0FA;EACE,iBAAA;EACA,kBAAA;AAvFF;;AAoGA;EACE,eAAA;AAjGF;;AAoGA;EACE,kBAAA;EACA,yBAAA;AAjGF;;AAqGA;EACE,yBAAA;AAlGF;;AAsGA;EAEE,kBAAA;AApGF;;AAuGA;EACE,UAAA;EACA,kBAAA;EACA,YAAA;AApGF;;AAuGA;EACE,mBAAA;AApGF;;AAuGA;EAEE,aAAA;AArGF;;AAwGA;EACE,gBAAA;AArGF;;AAwGA;EACE,2BAAA;EAAA,sBAAA;EACA,2BAAA;AArGF;;AAyGA;EACE,QAAA;AAtGF;;AAyGA;EAKE,kCAAA;EACA,WAAA;AAtGF;;AAyGA;EACE,YAAA;AAtGF;;AAyGA;EACE,iBAAA;AAtGF;;AAyGA;EACE,kBAAA;AAtGF;;AAyGA;EACE,WAAA;AAtGF;;AAyGA;EACE,WAAA;EACA,sBAAA;AAtGF;;AAyGA;EACE,mBAAA;AAtGF;;AAyGA;EACE,WAAA;EACA,sBAAA;AAtGF;;AAyGA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,gBAAA;AAvGF;;AA8GA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;AA3GF;;AAiHA;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;AA9GF;;AAsHA;EACE,eAAA;EAEA,WAAA;EAEA,YAAA;EACA,gBAAA;AArHF;;AAwHA;EACE,8DAAA;EAIA,kCAAA;EACA,UAAA;AArHF;;AAwHA;EACE,8DAAA;EAIA,kCAAA;EACA,UAAA;AArHF;;AAwHA;EACE,UAAA;AArHF;;AAwHA;EACE,UAAA;AArHF;;AAwHA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AArHF;;AAwHA;EACE,eAAA;AArHF","sourcesContent":["ion-input {\n  border-bottom: 1px solid;\n}\n\nion-item {\n  font-size: 0.9rem;\n  --min-height: 28px;\n}\n\nspan {\n}\n\n.editField>ion-item {\n  --min-height: 28px;\n}\n\n.fielditem {\n  --background: transparent;\n  background: transparent;\n  //--min-height: auto;\n}\n\nth span {\n}\n\n.modelRowContainer > div:nth-of-type(odd) {\n  background: #f2f2f2;\n}\n\n.modelRowContainer > div:nth-of-type(even) {\n  background: #ffffff;\n}\n\n.modelRow ion-item, .fieldcell .fieldcellItem {\n  //max-height: 31px;\n  //--min-height: 31px;\n}\n\n.fieldcell>div {\n  //background-color: white;\n}\n\n.fieldcell:nth-of-type(odd) {\n  //border-top: 1px solid #f4f4f4;\n  //border-bottom: 1px solid #f4f4f4;\n  //border-right: 3px solid #f4f4f4;\n  //border-left: 3px solid #f4f4f4;\n}\n\n.fieldcell:nth-of-type(even) {\n\n}\n\n.whiteBg {\n  background: #ffffff;\n}\n\nion-item {\n  padding: 0px;\n  //background-color: transparent;\n}\n\n.listTable td {\n  border: 0px solid #ddd;\n  //padding: 3.5px;\n  line-height: 1.4rem;\n}\n\n.listTable td {\n  border-bottom: 1px solid #ddd;\n}\n\nth {\n  white-space: nowrap;\n  padding: 5px;\n}\n\n.showScrollX {\n  width: 100%;\n  overflow-x: scroll;\n  overscroll-behavior: contain;\n}\n\n.showScrollY {\n  height: 700px;\n  overflow-y: scroll;\n  overscroll-behavior: contain;\n}\n\n\n.regTd {\n  //padding: 3px;\n  //margin: 1px;\n  //border: 1px solid #aeaead;\n  //max-width: 140px;\n  //display: flex;\n}\n\n\n.regTd > div:nth-of-type(odd) {\n  background: #f2f2f2;\n}\n\n.regTd > div:nth-of-type(even) {\n  background: #ffffff;\n}\n\n\n.regTd > ion-item {\n  background: transparent;\n  //display: flex;\n}\n\n.regTd > ion-item .item-inner {\n  overflow: hidden;\n  //height: 70px;\n  background: transparent;\n}\n\n.inTableImage {\n  max-width: 30px;\n  max-height: 30px;\n  //padding-right: 3px;\n  //width: auto;\n}\n\n.inTableImage ion-img,\n.inTableImage img {\n  max-width: 60px;\n  max-height: 60px;\n}\n\n.myrowContainer {\n  //height: 31px;\n}\n\n.myrow:hover {\n  //background: #b1b1b1;\n}\n\n.datarow:hover {\n  //background: #efefef;\n  border: 1px solid black;\n}\n\n.myrow {\n  display: flex;\n  //display: -webkit-box;\n  ////border-bottom: 1px solid #a3a1a3;\n  //display: flex;\n  //flex-wrap: wrap;\n}\n\n.fieldcell {\n  //height: 31px;\n  //max-height: 31px;\n}\n\n.displayNameField {\n  box-shadow: rgb(45, 45, 45) 0px 0px 1px;\n}\n\n.myrow div {\n  //padding: 5px;\n\n}\n\n.td1 {\n  display: flex;\n  flex-basis: 20px;\n}\n\n.td2 {\n  display: flex;\n  flex-basis: 20px;\n}\n\n.td12 .checkMarkInTd {\n  display: none;\n}\n\n.td12:hover .checkMarkInTd {\n  display: block;\n}\n\n.tdCheckBox {\n  max-height: 60px;\n}\n\n.thDisplayName {\n  flex-basis: 110px;\n}\n\n.td12 {\n  position: relative;\n  z-index: 22;\n  align-content: flex-start;\n  display: flex;\n  flex-basis: 100px;\n  //padding: 5px;\n  background-color: #e1e1e1;\n\n  width: 100px;\n  max-width: 100px;\n}\n\n.td15 {\n  z-index: 999999;\n  flex-basis: 225px;\n  max-width: 225px;\n}\n\n.td12marginTop {\n  //margin-top: 5px;\n}\n\n.noScroll {\n  -webkit-animation: fadeInFromNone 0.5s ease-out;\n  -moz-animation: fadeInFromNone 0.5s ease-out;\n  -o-animation: fadeInFromNone 0.5s ease-out;\n  animation: fadeInFromNone 0.5s ease-out;\n}\n\n@keyframes fadeInFromNone {\n  0% {\n    display: none;\n    opacity: 0;\n  }\n\n  1% {\n    display: block;\n    opacity: 0;\n  }\n\n  100% {\n    display: block;\n    opacity: 1;\n  }\n}\n\n.onScroll {\n  opacity: 0;\n}\n\n.tDtransition {\n  transition: flex-basis 0.3s;\n  transform: translateX(-3000);\n  animation: translateXAnimation 2s none;\n}\n\n@keyframes translateXAnimation {\n  0% {\n    transform: translateX(00);\n  }\n}\n\n.tDwidtherOnHover {\n  transition: flex-basis 0.3s;\n}\n\n.tDwidtherOnHover:hover span {\n  width: 35px;\n  padding-left: 10px;\n}\n\n.tDwidtherOnHover:hover {\n  flex-basis: 65px;\n  cursor: pointer;\n}\n\n.tDwidtherOnHover1:hover {\n  flex-basis: 90px;\n  cursor: pointer;\n}\n\n.nottDwidtherChecked {\n  flex-basis: 20px;\n}\n\n.tDwidtherChecked {\n  flex-basis: 45px;\n  cursor: pointer;\n}\n\n.tDwidtherChecked1 {\n  flex-basis: 90px;\n  cursor: pointer;\n}\n\n.disabledDiv {\n  background-color: #d3e2ff;\n}\n\n.onFieldMouseOver {\n  background-color: #fac75a;\n}\n\n.thButtonCOl {\n  display: flex;\n  flex-basis: 140px;\n}\n\n.th3 {\n  display: flex;\n  //background: white;\n  flex-basis: 300px;\n  //padding: 5px;\n  //color: white;\n  //height: 35px;\n  background: white;\n  position: relative;\n  z-index: 213332;\n  //background-color: rgba(42, 45, 69, 0.95);\n}\n\n.td3 {\n  display: flex;\n  flex-basis: 300px;\n  //padding: 5px;\n  color: white;\n  //height: 70px;\n  //background: white;\n  //background-color: rgba(42, 45, 69, 0.95);\n  position: relative;\n  z-index: 22;\n  padding: 0px 3px;\n}\n\n\n.borderit {\n  border-right: 1px solid #c7c7c7;\n}\n\n.mainBackcolor {\n  background-color: var(--ion-color-secondary);\n}\n\n.mainBackcolor1 {\n  background-color: var(--ion-color-warning);\n}\n\n.tdId {\n  display: flex;\n  flex-basis: 100px;\n}\n\n.fullFlex {\n  flex-basis: 100%;\n}\n\n.Flex80 {\n  flex-basis: 80%;\n}\n\n\n.sidecard {\n  max-height: 661px;\n  overflow-x: scroll;\n\n  //top: 63px;\n  //background: white;\n  //position: fixed;\n  //right: 0px;\n  //z-index: 100;\n  //width: 300px;\n  //padding: 5px;\n  //border: 1px solid;\n  //height: 100%;\n}\n\n.showOnHover {\n  cursor: pointer;\n}\n\n.showOnHover:hover {\n  border: 1px dashed;\n  background-color: #efefef;\n  //flex-basis: 200px;\n}\n\n.showOnHoverDark:hover {\n  background-color: #bebebe;\n}\n\n\n.showOnHover .showOnHoverSon {\n  //display: none;\n  visibility: hidden;\n}\n\n.showOnHover .showOnHoverSonTop {\n  top: -20px;\n  position: relative;\n  z-index: 111;\n}\n\n.showOnHover:hover .showOnHoverSon {\n  visibility: visible;\n}\n\n.displayOnHover2 .displayOnHoverSon2 {\n  //display: none;\n  display: none;\n}\n\n.displayOnHover2:hover .displayOnHoverSon2 {\n  display: initial;\n}\n\n.tdFullOnHover:hover {\n  min-width: fit-content;\n  flex-basis: auto !important;\n}\n\n\n.transitionFromHidden {\n  width: 0;\n}\n\n.transitionFromHiddenOpen {\n  -webkit-transition: width 0.5s ease-in-out;\n  -moz-transition: width 0.5s ease-in-out;\n  -ms-transition: width 0.5s ease-in-out;\n  -o-transition: width 0.5s ease-in-out;\n  transition: width 0.5s ease-in-out;\n  width: auto;\n}\n\n.checkButton ion-button {\n  height: 80px;\n}\n\n.checkButton ion-icon {\n  font-size: 1.5rem;\n}\n\n.boxCheck ion-icon {\n  visibility: hidden;\n}\n\n.boxCheck {\n  width: 30px;\n}\n\n.boxCheck:hover {\n  width: 70px;\n  transition: width 0.3s;\n}\n\n.boxCheck:hover ion-icon {\n  visibility: visible;\n}\n\n.middleBoxSmaller {\n  width: 50px;\n  transition: width 0.3s;\n}\n\n.field {\n  white-space: break-spaces;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  //position: relative;\n  max-height: 60px;\n  //overflow: auto;\n  //background: white;\n  //white-space: nowrap;\n  //padding: 0px 7px;\n}\n\n.listTableContainerSide {\n  width: 100%;\n  max-height: 700px;\n  overflow-y: scroll;\n}\n\n.addRelationModelButton {\n}\n\n.addNew {\n  max-width: 700px;\n  border-color: #a3a3a3;\n  border: 1px dashed;\n}\n\n.boxShow {\n  //margin: 0px 0px 19px 0px;\n  //border-bottom: 5px solid;\n}\n\n.boxView {\n  max-width: 100%;\n  //width: 100%;\n  float: left;\n  //max-width: 400px;\n  padding: 8px;\n  min-width: 300px;\n}\n\n.modelRow {\n  -webkit-transition-webkit-transition: opacity 0.5s ease-in-out;\n  -moz-transition: opacity 1s ease-in-out;\n  -ms-transition: opacity 1s ease-in-out;\n  -o-transition: opacity 1s ease-in-out;\n  transition: opacity 1s ease-in-out;\n  opacity: 1;\n}\n\n.opacityTransition {\n  -webkit-transition-webkit-transition: opacity 0.5s ease-in-out;\n  -moz-transition: opacity 3s ease-in-out;\n  -ms-transition: opacity 3s ease-in-out;\n  -o-transition: opacity 3s ease-in-out;\n  transition: opacity 3s ease-in-out;\n  opacity: 1;\n}\n\n.modelRemoved {\n  opacity: 0;\n}\n\n.onRefresh {\n  opacity: 0;\n}\n\n.sticktTableHeader {\n  position: fixed;\n  z-index: 19911;\n  margin-bottom: 8px;\n  top: 60px;\n}\n\n.relationOpenMain {\n  flex-basis: 80%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
